import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../helpers';

// create slice

const name = 'parametres';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const parametreActions = { ...slice.actions, ...extraActions };
export const parametresReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        parametres: {},
        parametresLoad:false,
        error: null
    }
}

function createExtraActions() {

    const baseUrl = `${import.meta.env.VITE_API_URL}/api/parametres/`;

    return {
      getAll: getAll()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async (user) => fetchWrapper.get(baseUrl,'',user)
        );
    }
}

function createExtraReducers() {
    return (builder) => {
        builder
            .addCase(extraActions.getAll.pending, (state, action) => {
                state.error = action.error;
                state.parametresLoad = false;
            })
            .addCase(extraActions.getAll.fulfilled, (state, action) => {
                state.parametres = action.payload;
                state.parametresLoad = true;
            })
            .addCase(extraActions.getAll.rejected, (state, action) => {
                state.error = action.error;
            });
    };
}
